import React, { Component } from "react";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Container, Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Switch from "@material-ui/core/Switch";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import api from "../api";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuActions from "../MenuActions";
import MediaComponent from "../../../components/common/Media";
import NumberFormat from "react-number-format";
import ValetBudgetComponent from "./ValetBudget";
import CompareBudgets from "./CompareBudgets";
import Chip from "@material-ui/core/Chip";
import Checkbox from "@material-ui/core/Checkbox";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  tableCell: {
    padding: "8px 4px 8px 4px",
    border: "1px solid #dee2e6"
  }
});

class Budget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openPresupuesto: false,
      snackbar: { open: false, severity: "success", message: "" },
      budgets: [{ provider: { business_name: "" } }],
      id: "",
      tasks: { tasks: [{ task: { name: "" } }], loading: false, options: [] },
      tasks_groups: [],
      task_sub_groups: [],
      subtotals: {
        price: { materials: 0, workforce: 0, total: 0 },
        discount: { materials: 0, workforce: 0, total: 0 }
      },
      payment_in_advance: "",
      due_date: "",
      shift_date: "",
      media: [],
      dialog: { open: false },
      action: "",
      materials_discount: 0,
      workforce_discount: 0,
      total_discount: 0,
      providers: {
        loading: false,
        open: false,
        options: [{ business_name: "" }],
        provider: {}
      },
      openCompare: false
    };

    this.handleCloseSuccess = this.handleCloseSuccess.bind(this);
    this.handleAddPresupuesto = this.handleAddPresupuesto.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleNewPresupuesto = this.handleNewPresupuesto.bind(this);
    this.handleClosePresupuesto = this.handleClosePresupuesto.bind(this);
    this.handleOpenCompare = this.handleOpenCompare.bind(this);
    this.handleCloseCompare = this.handleCloseCompare.bind(this);
  }

  async componentDidMount() {
    var due_date = new Date();
    due_date.setDate(due_date.getDate() + 15);
    due_date =
      due_date.getFullYear() +
      "-" +
      String(due_date.getMonth() + 1).padStart(2, "0") +
      "-" +
      due_date.getDate();
    this.setState({ due_date: due_date });
    var work_order = {
      id: this.props.work_order.id,
      shift_date: this.props.work_order.shift_date
    };
    var tasks = this.state.tasks;
    tasks.tasks = this.props.tasks.tasks.tasks;
    await this.getBudgets(this.props.work_order.id);
    await this.getTasksGroups();
    this.setState({ tasks: tasks, work_order: work_order });
  }

  getTasksGroups = () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.tasks, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        var tasks_groups = this.state.tasks_groups;
        tasks_groups = res.data;
        this.setState({ tasks_groups: tasks_groups });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleTasksAsyncChange = (event, values) => {
    var id = event.target.id.replace("-option-0", "").split(".");
    var tasks = this.state.tasks;
    var task =
      values !== null ? { task: values } : { task: { id: "", name: "" } };
    if (values !== null) {
      task.id = "";
      task.task_sub_group = values.task_sub_group;
      task.task_group = values.task_group;
      if (task.task_sub_group === undefined) {
        var tasks_groups = this.state.tasks_groups;
        var task_sub_groups = this.state.task_sub_groups;
        var sub_group = task_sub_groups.filter(
          sub_group => sub_group.id === parseInt(values.parent_id)
        );
        var group = tasks_groups.filter(
          group => group.id === parseInt(sub_group[0].parent_id)
        );
        task.task.task_sub_group = sub_group[0].label;
        task.task.task_group = group[0].label;
      }
    }
    task.total_s_iva_price = 0;
    task.materials_s_iva_price = 0;
    task.workforce_s_iva_price = 0;
    tasks.tasks[tasks.tasks.length - 1] = task;
    //    	tasks.tasks = tasks.tasks.push(values)
    this.setState({ tasks: tasks });
  };

  handleTasksAsyncSearch = (event, values) => {
    var task = values;
    const token = localStorage.getItem("userToken");
    if (task.length > 2) {
      return axios
        .get(api.work_order().tasks_autocomplete(task), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var tasks = this.state.tasks;
          tasks.options = res.data;
          this.setState({ tasks: tasks });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleMenuAction = (e, action, id) => {
    e.preventDefault();
    e.stopPropagation();
    var budget_id = this.state.budgets[id].id;
    switch (action) {
      case "Exportar detallado":
        this.handleExportBudget(budget_id, 1);
        return;
      case "Exportar semidetallado":
        this.handleExportBudget(budget_id, 2);
        return;
      case "Exportar cerrado":
        this.handleExportBudget(budget_id, 0);
        return;
      case "recotizar":
        return;
      case "Verificar":
        this.handleApproveBudget(budget_id);
        return;
      case "Editar":
        if (this.state.budget_component === "Budget") {
          var providers = this.state.providers;
          var tasks = this.state.tasks;
          //				tasks.tasks = (this.state.budgets[id].tasks.length > 0) ? this.state.budgets[id].tasks : this.props.tasks.tasks.tasks
          tasks.tasks = this.state.budgets[id].tasks;
          if (tasks.tasks.length === 0) {
            var task = { task: { id: "", name: "" } };
            tasks.tasks.push(task);
          }
          //					tasks.tasks = (tasks.tasks.length > 0) ? tasks.tasks : tasks.tasks.push()
          providers.provider = {
            business_name: this.state.budgets[id].provider.business_name,
            id: this.state.budgets[id].provider.id
          };
          providers.options = [
            { business_name: this.state.budgets[id].provider.business_name }
          ];
          this.setState({
            id: this.state.budgets[id].id,
            providers: providers,
            due_date: this.state.budgets[id].due_date,
            payment_in_advance: this.state.budgets[id].payment_in_advance,
            tasks: tasks,
            media: this.state.budgets[id].media,
            action: "edit",
            materials_discount: 0,
            workforce_discount: 0,
            total_discount: 0,
            subtotals: {
              price: { materials: 0, workforce: 0, total: 0 },
              discount: { materials: 0, workforce: 0, total: 0 }
            }
          });
        } else {
          this.setState({ id: this.state.budgets[id].id });
        }
        this.calculateSubtotals();
        this.handleClickOpen();
        return;
      case "Ver":
        var providers = this.state.providers;
        var tasks = this.state.tasks;
        tasks.tasks =
          this.state.budgets[id].tasks.length > 0
            ? this.state.budgets[id].tasks
            : this.props.tasks.tasks.tasks;

        providers.provider = {
          business_name: this.state.budgets[id].provider.business_name,
          id: this.state.budgets[id].provider.id
        };
        providers.options = [
          { business_name: this.state.budgets[id].provider.business_name }
        ];
        this.setState({
          id: this.state.budgets[id].id,
          providers: providers,
          due_date: this.state.budgets[id].due_date,
          payment_in_advance: this.state.budgets[id].payment_in_advance,
          tasks: tasks,
          media: this.state.budgets[id].media,
          action: "view"
        });
        this.calculateSubtotals();
        this.handleClickOpen();
        return;
    }
  };

  handleExportBudget = (id, detailed) => {
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(api.budgets().export(id, detailed), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob"
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          "Informe_Orden de trabajo_" +
            this.props.work_order.id +
            "_" +
            this.props.plate +
            ".pdf"
        ); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleApproveBudget = id => {
    var formData = new FormData();
    formData.set("budget[id]", id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.budgets().approve(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          message: "Presupuesto verificado con éxito",
          severity: "success"
        };
        this.setState({ snackbar });
        this.props.onUpdateWorkOrderState();
        this.getBudgets(this.props.work_order.id);
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido un error al cargar el presupuesto.";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              error_message = "";
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message
              .concat(errors.errors.message)
              .concat(" ");
          }
        }
        var snackbar = {
          open: true,
          message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar });
      });

    //this.getBudgets(this.props.work_order.id)
  };

  handleClickOpen() {
    this.setState({ openPresupuesto: true });
  }

  handleNewPresupuesto() {
    var providers = this.state.providers;
    var budgets = this.state.budgets;
    if (budgets.length === 1) {
      providers.provider = {
        business_name: this.state.budgets[0].provider.business_name,
        id: this.state.budgets[0].provider.id
      };
      providers.options = [
        { business_name: this.state.budgets[0].provider.business_name }
      ];
    }

    this.setState({ openPresupuesto: true, id: "", providers: providers });
  }

  handleClosePresupuesto() {
    this.setState({ openPresupuesto: false });
    this.getBudgets(this.props.work_order.id);
  }

  handleOpenCompare() {
    this.setState({ openCompare: true });
  }

  handleCloseCompare() {
    this.setState({ openCompare: false });
  }

  handleCloseSuccess() {
    var snackbar = { open: false, message: "", severity: "success" };
    /*  		if (this.state.openPresupuesto === false){
	  		this.getBudgets(this.props.work_order.id)
  		}
*/
    this.setState({ snackbar: snackbar });
  }

  handleProvidersAsyncChange = (event, values) => {
    var providers = this.state.providers;
    values = values !== null ? values : { business_name: "" };
    providers.provider = values;
    this.setState({ providers: providers });
  };

  handleProvidersAsyncSearch = (event, values) => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", ""), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers = this.state.providers;
          providers.options = res.data.data;
          this.setState({ providers: providers });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleNewTask = e => {
    e.preventDefault();
    var tasks = this.state.tasks;
    tasks.tasks.push({
      task: { id: "", name: "" },
      workforce_s_iva_price: 0,
      total_s_iva_price: 0,
      materials_s_iva_price: 0
    });
    this.setState({ tasks: tasks });
  };

  handleRemoveTask = (e, id) => {
    e.preventDefault();
    var tasks = this.state.tasks;
    tasks.tasks[id].deleted_at = 1;
    var deleted_tasks = tasks.tasks.filter(
      (s, sidx) => s.deleted_at !== undefined
    );
    if (deleted_tasks.length === tasks.tasks.length) {
      tasks.tasks.push({
        task: { id: "", name: "" },
        workforce_s_iva_price: 0,
        total_s_iva_price: 0,
        materials_s_iva_price: 0
      });
    }
    this.setState({ tasks: tasks });
    this.calculateSubtotals();
  };

  handleChange = e => {
    var tasks = this.state.tasks;
    if (e.target.name === "payment_in_advance") {
      this.setState({ payment_in_advance: e.target.checked });
    } else if (e.target.name === "due_date") {
      this.setState({ due_date: e.target.value });
    } else if (e.target.name === "return_date") {
      this.setState({ return_date: e.target.value });
    } else if (
      ["workforce_discount", "materials_discount", "total_discount"].includes(
        e.target.name
      )
    ) {
      this.setState({ [e.target.name]: e.target.value.replace("%", "") });
    } else {
      var element = e.target.name.split(".");
      var key = element[0];
      var id = element[1];
      if (key === "task_group" || key === "task_sub_group") {
        var task_sub_groups = this.state.task_sub_groups;
        var tasks_groups = this.state.tasks_groups;
        if (key === "task_group") {
          var group = tasks_groups.filter(
            group => group.id === parseInt(e.target.value)
          );
          task_sub_groups = group[0].children;
          this.setState({ task_sub_groups: task_sub_groups });
        } else {
          var sub_group = task_sub_groups.filter(
            sub_group => sub_group.id === parseInt(e.target.value)
          );
          var options = sub_group[0].children;
          tasks.options = options;
        }
      }
      if (key === "bonificado") {
        var checked = e.target.checked;
        tasks.tasks[id][key] = checked;
        var totalLine = tasks.tasks[id]["total_s_iva_price"] || 0;
        tasks.tasks[id]["total_discount"] = checked ? totalLine : (tasks.tasks[id]["total_discount"] || 0);
      } else {
        tasks.tasks[id][key] = e.target.value.replace("$", "");
      }
      //			tasks.tasks[id][key] = parseFloat(e.target.value.toString().replace('$','').replace(/\./g,''))
    }
    this.setState({ tasks });
    //		if (['workforce_s_iva_price', 'materials_s_iva_price'].includes(key)){
    this.calculateSubtotals();
    //		}
  };

  getBudgets(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.work_order().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({
          budgets: res.data.budgets,
          budget_component: res.data.budget_component,
          tasks: {
            tasks: [{ task: { name: "" } }],
            loading: false,
            options: []
          },
          payment_in_advance: "",
          //due_date:'',
          media: []
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleUpload = files => {
    this.setState({
      files: files
    });
  };

  handleAddPresupuesto() {
    var formData = new FormData();
    var url = api.budgets().post();
    formData.set("budget[version]", "1.0");
    formData.set("budget[work_order_id]", this.state.work_order.id);
    formData.set(
      "budget[provider_id]",
      this.state.providers.provider.id ? this.state.providers.provider.id : ""
    );
    formData.set("budget[budget_type_id]", "8");
    formData.set("budget[budget_state_id]", "3");
    formData.set("budget[due_date]", this.state.due_date);
    formData.set(
      "budget[return_date]",
      this.state.return_date ? this.state.return_date : ""
    );

    formData.set(
      "budget[payment_in_advance]",
      this.state.payment_in_advance ? 1 : 0
    );

    this.state.tasks.tasks.map((val, idx) => {
      if (val.task.id) {
        if (val.id) {
          formData.set("tasks[" + idx + "][id]", val.id);
        }
        formData.set("tasks[" + idx + "][task_id]", val.task.id);
        formData.set(
          "tasks[" + idx + "][workforce_s_iva_price]",
          val.workforce_s_iva_price
        );
        formData.set(
          "tasks[" + idx + "][materials_s_iva_price]",
          val.materials_s_iva_price
        );
        formData.set(
          "tasks[" + idx + "][total_s_iva_price]",
          val.total_s_iva_price
        );
        formData.set(
          "tasks[" + idx + "][total_discount]",
          val.bonificado === true
            ? (val.total_s_iva_price || 0)
            : (+val.workforce_discount + +val.materials_discount
                ? +val.workforce_discount + +val.materials_discount
                : 0)
        );
        formData.set(
          "tasks[" + idx + "][materials_discount]",
          val.materials_discount ? val.materials_discount : 0
        );
        formData.set(
          "tasks[" + idx + "][workforce_discount]",
          val.workforce_discount ? val.workforce_discount : 0
        );
        if (val.deleted_at) {
          formData.set(
            "tasks[" + idx + "][deleted_at]",
            new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " ")
          );
        }
      }
    });
    // Subtotales
    // Descuentos
    formData.set(
      "budget[workforce_discount]",
      this.state.workforce_discount ? this.state.workforce_discount : 0
    );
    formData.set(
      "budget[materials_discount]",
      this.state.materials_discount ? this.state.materials_discount : 0
    );
    formData.set(
      "budget[total_discount]",
      this.state.total_discount ? this.state.total_discount : 0
    );
    // Montos
    formData.set(
      "budget[workforce_s_iva_price]",
      this.state.subtotals.price.workforce
        ? this.state.subtotals.price.workforce
        : 0
    );
    formData.set(
      "budget[materials_s_iva_price]",
      this.state.subtotals.price.materials
        ? this.state.subtotals.price.materials
        : 0
    );
    formData.set(
      "budget[total_s_iva_price]",
      this.state.subtotals.price.total ? this.state.subtotals.price.total : 0
    );

    if (this.state.id !== "") {
      formData.set("budget[id]", this.state.id);
      url = api.budgets().patch(this.state.id);
      formData.set("_method", "PATCH");
    }

    if (this.state.files) {
      this.state.files.map((val, idx) => {
        formData.set(`media[${idx}]`, val);
      });
    }

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          message: "Presupuesto cargado con éxito",
          severity: "success"
        };
        this.setState({ snackbar: snackbar });
        this.handleClosePresupuesto();
        this.props.onUpdateWorkOrderState();
        //this.getBudgets(this.props.work_order.id)
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido un error al cargar el presupuesto.";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              error_message = "";
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message
              .concat(errors.errors.message)
              .concat(" ");
          }
        }

        var snackbar = {
          open: true,
          message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  }

  calculateSubtotals = () => {
    var subtotals = {
      price: { materials: 0, workforce: 0, total: 0 },
      discount: { materials: 0, workforce: 0, total: 0 }
    };
    var tasks_subtotals = this.state.tasks.tasks;
    for (var i = 0; i < tasks_subtotals.length; i++) {
      if (!tasks_subtotals[i].deleted_at) {
        if (tasks_subtotals[i].total_s_iva_price === undefined) {
          tasks_subtotals[i].total_s_iva_price = 0;
        }

        /*		    	if (tasks_subtotals[i].materials_s_iva_price > 0){
		    		tasks_subtotals[i].total_s_iva_price = parseFloat(tasks_subtotals[i].materials_s_iva_price)
		    	}
		    	if (tasks_subtotals[i].workforce_s_iva_price > 0 ){
		    		tasks_subtotals[i].total_s_iva_price += parseFloat(tasks_subtotals[i].workforce_s_iva_price) 
		    	}*/
        if (
          parseFloat(tasks_subtotals[i].workforce_s_iva_price) > 0 ||
          parseFloat(tasks_subtotals[i].materials_s_iva_price) > 0
        ) {
          tasks_subtotals[i].total_s_iva_price =
            parseFloat(tasks_subtotals[i].workforce_s_iva_price) +
            parseFloat(tasks_subtotals[i].materials_s_iva_price);
        }
        subtotals.price.materials += tasks_subtotals[i].materials_s_iva_price
          ? +parseFloat(tasks_subtotals[i].materials_s_iva_price)
          : 0;
        subtotals.price.workforce += tasks_subtotals[i].workforce_s_iva_price
          ? +parseFloat(tasks_subtotals[i].workforce_s_iva_price)
          : 0;

        subtotals.price.total += +parseFloat(
          tasks_subtotals[i].total_s_iva_price
        );
        subtotals.price.materials = Number(
          subtotals.price.materials.toFixed(2)
        );
        subtotals.price.workforce = Number(
          subtotals.price.workforce.toFixed(2)
        );
        subtotals.price.total = Number(subtotals.price.total.toFixed(2));

        //tasks_subtotals[i].total_s_iva_price = 100;

        //subtotals.price.total += (tasks[i].total) ? +parseFloat(tasks[i].total) : 0
        //subtotals.discount.materials += (tasks[i].materials_discount) ? +parseFloat(tasks[i].materials_discount) : 0
        //subtotals.discount.workforce += (tasks[i].workforce_discount) ? +parseFloat(tasks[i].workforce_discount) : 0
        //subtotals.discount.total += (tasks[i].total_discount) ? +parseFloat(tasks[i].total_discount) : 0
      }
    }
    if (this.state.materials_discount > 0) {
      subtotals.price.materials =
        subtotals.price.materials -
        (subtotals.price.materials * this.state.materials_discount) / 100;
      subtotals.price.total =
        subtotals.price.materials + subtotals.price.workforce;
    }
    if (this.state.workforce_discount > 0) {
      subtotals.price.workforce =
        subtotals.price.workforce -
        (subtotals.price.workforce * this.state.workforce_discount) / 100;
      subtotals.price.total =
        subtotals.price.materials + subtotals.price.workforce;
    }
    if (this.state.total_discount > 0) {
      subtotals.price.total =
        subtotals.price.total -
        (subtotals.price.total * this.state.total_discount) / 100;
    }
    var tasks = this.state.tasks;
    tasks.tasks = tasks_subtotals;
    this.setState({ subtotals, tasks });
  };

  render() {
    var subtotals = this.state.subtotals;
    const classes = this.props.classes;
    const parseMoney = v => {
      if (v === null || v === undefined) return 0;
      if (typeof v === "number") return v;
      const n = parseFloat(String(v).replace(/[$,\s]/g, ""));
      return isNaN(n) ? 0 : n;
    };
    const approvedTotal = (() => {
      const approved = this.state.budgets.find(b => b && b.budget_state_id === 2);
      if (!approved) return 0;
      return this.state.budget_component !== "ValetBudget"
        ? (approved.total_budget !== undefined ? parseMoney(approved.total_budget) : 0)
        : (approved.total_s_iva_price !== undefined ? parseMoney(approved.total_s_iva_price) : 0);
    })();
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={10000}
          onClose={this.handleCloseSuccess}
        >
          <Alert
            onClose={this.handleCloseSuccess}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.message}
          </Alert>
        </Snackbar>
        <Dialog
          fullScreen
          open={this.state.openPresupuesto}
          onClose={this.handleClosePresupuesto}
          TransitionComponent={Transition}
        >
          <React.Fragment>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.handleClosePresupuesto}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Agregar presupuesto
                </Typography>
              </Toolbar>
            </AppBar>
            {this.state.budget_component === "Budget" ? (
              <React.Fragment>
                <div className="row mt-2 ml-4">
                  <Autocomplete
                    id="provider"
                    style={{ width: 200 }}
                    getOptionLabel={option => option.business_name}
                    getOptionSelected={(option, value) =>
                      option.business_name === value
                    }
                    options={this.state.providers.options}
                    loading={this.state.providers.loading}
                    onInputChange={this.handleProvidersAsyncSearch}
                    onChange={this.handleProvidersAsyncChange.bind(this)}
                    value={
                      this.state.providers.options.find(
                        v =>
                          v.business_name ===
                          this.state.providers.provider.business_name
                      ) || {}
                    }
                    autoComplete
                    noOptionsText={
                      <Typography variant="caption">Sin resultados</Typography>
                    }
                    name="provider"
                    includeInputInList
                    className="mt-3 mr-2"
                    classes={{
                      option: classes.option
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        placeholder="Ingrese un proveedor"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {this.state.providers.loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                        InputLabelProps={{
                          ...params.InputLabelProps,
                          shrink: true
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: "0.75rem", width: 70 }
                        }}
                      />
                    )}
                  />
                  <TextField
                    id="return_date"
                    value={this.state.return_date}
                    label="Fecha de dispoinibilidad"
                    onChange={this.handleChange}
                    type="date"
                    required
                    name="return_date"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 200, fontSize: "0.75rem" }
                    }}
                  />
                  <TextField
                    id="due_date"
                    value={this.state.due_date}
                    label="Fecha de caducidad"
                    onChange={this.handleChange}
                    type="date"
                    required
                    name="due_date"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 200, fontSize: "0.75rem" }
                    }}
                  />
                  <FormControlLabel
                    className={classes.SwitchLabel}
                    control={
                      <Switch
                        id="payment_in_advance"
                        onChange={this.handleChange}
                        checked={this.state.payment_in_advance}
                        name="payment_in_advance"
                        size="small"
                        color="primary"
                        className="mt-1"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    }
                    label={
                      <Typography style={{ fontSize: "0.75rem" }}>
                        Requiere pago adelantado?
                      </Typography>
                    }
                    labelPlacement="top"
                  />
                </div>
                <div className="row mt-2 ml-4">
                  <Table
                    size="small"
                    aria-label="a dense table"
                    style={{ width: "auto" }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Grupo
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Subgrupo
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Tarea
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Mano de obra S/IVA
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Repuestos S/IVA
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Total S/IVA
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Bonificado
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.tasks.tasks.map((val, idx) => {
                        if (!val.deleted_at) {
                          return (
                            <TableRow>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.7rem" }}
                              >
                                {val.task.task_group ? (
                                  <div>{val.task.task_group}</div>
                                ) : (
                                  <FormControl
                                    style={{ fontSize: "0.75rem" }}
                                    name={"task_group." + idx}
                                  >
                                    <Select
                                      native
                                      name={"task_group." + idx}
                                      inputProps={{
                                        name: "task_group." + idx,
                                        className: "task_group." + idx
                                      }}
                                      value={
                                        val.task_group ? val.task_group : ""
                                      }
                                      style={{ fontSize: "0.75rem" }}
                                      onChange={this.handleChange}
                                      required
                                      input={
                                        <Input
                                          id="grouped-native-select"
                                          name="contract_id"
                                        />
                                      }
                                    >
                                      <option value="" />
                                      {this.state.tasks_groups.map(
                                        task_group => (
                                          <option
                                            id={task_group.name}
                                            value={task_group.id}
                                          >
                                            {task_group.name}
                                          </option>
                                        )
                                      )}
                                    </Select>
                                  </FormControl>
                                )}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.7rem" }}
                              >
                                {val.task.task_sub_group ? (
                                  <div>{val.task.task_sub_group}</div>
                                ) : (
                                  <FormControl
                                    style={{ fontSize: "0.75rem" }}
                                    name={"task_sub_group." + idx}
                                  >
                                    <Select
                                      native
                                      name={"task_sub_group." + idx}
                                      inputProps={{
                                        name: "task_sub_group." + idx,
                                        className: "task_sub_group." + idx
                                      }}
                                      value={
                                        val.task_sub_group
                                          ? val.task_sub_group
                                          : ""
                                      }
                                      style={{ fontSize: "0.75rem" }}
                                      onChange={this.handleChange}
                                      required
                                      input={
                                        <Input
                                          id="grouped-native-select"
                                          name="contract_id"
                                        />
                                      }
                                    >
                                      <option value="" />
                                      {this.state.task_sub_groups.map(
                                        task_sub_group => (
                                          <option
                                            id={task_sub_group.name}
                                            value={task_sub_group.id}
                                          >
                                            {task_sub_group.name}
                                          </option>
                                        )
                                      )}
                                    </Select>
                                  </FormControl>
                                )}
                              </TableCell>

                              <TableCell className={classes.tableCell}>
                                {val.task.id === "" ||
                                val.task.id === undefined ? (
                                  <Autocomplete
                                    id={"tasks." + idx}
                                    style={{ width: 200 }}
                                    getOptionLabel={option => option.name}
                                    getOptionSelected={(option, value) =>
                                      option.name === value
                                    }
                                    options={this.state.tasks.options}
                                    loading={this.state.tasks.loading}
                                    onInputChange={this.handleTasksAsyncSearch}
                                    onChange={this.handleTasksAsyncChange.bind(
                                      this
                                    )}
                                    autoComplete
                                    noOptionsText={
                                      <Typography variant="caption">
                                        Sin resultados
                                      </Typography>
                                    }
                                    name="tasks"
                                    includeInputInList
                                    className="mt-2 mr-2"
                                    classes={{
                                      option: classes.option
                                    }}
                                    renderInput={params => (
                                      <TextField
                                        {...params}
                                        placeholder="Ingrese una tarea"
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <React.Fragment>
                                              {this.state.tasks.loading ? (
                                                <CircularProgress
                                                  color="inherit"
                                                  size={20}
                                                />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </React.Fragment>
                                          )
                                        }}
                                        InputLabelProps={{
                                          ...params.InputLabelProps,
                                          shrink: true
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          style: {
                                            fontSize: "0.75rem",
                                            width: 70
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <TextField
                                    id="name"
                                    disabled={true}
                                    placeholder="Buscar tarea"
                                    value={val.task.name}
                                    onChange={this.handleChange}
                                    required
                                    name="name"
                                    margin="normal"
                                    className="m-0 p-0"
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    inputProps={{
                                      style: {
                                        minWidth: 200,
                                        fontSize: "0.75rem"
                                      }
                                    }}
                                  />
                                )}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <NumberFormat
                                  id={"workforce_s_iva_price." + idx}
                                  name={"workforce_s_iva_price." + idx}
                                  placeholder="Ingrese el valor de mano de obra"
                                  value={val.workforce_s_iva_price}
                                  onChange={this.handleChange}
                                  className="m-0 p-0"
                                  InputProps={{
                                    style: {
                                      minWidth: 100,
                                      fontSize: "0.75rem"
                                    }
                                  }}
                                  decimalSeparator="."
                                  prefix={"$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  customInput={TextField}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  isAllowed={values => {
                                    let { floatValue } = values;
                                    floatValue =
                                      floatValue !== undefined ? floatValue : 0;
                                    return (
                                      floatValue >= 0 && floatValue < 99999999
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <NumberFormat
                                  id={"materials_s_iva_price." + idx}
                                  name={"materials_s_iva_price." + idx}
                                  placeholder="Ingrese el valor de materiales"
                                  value={val.materials_s_iva_price}
                                  onChange={this.handleChange}
                                  className="m-0 p-0"
                                  InputProps={{
                                    style: {
                                      minWidth: 100,
                                      fontSize: "0.75rem"
                                    }
                                  }}
                                  decimalSeparator="."
                                  prefix={"$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  customInput={TextField}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  isAllowed={values => {
                                    let { floatValue } = values;
                                    floatValue =
                                      floatValue !== undefined ? floatValue : 0;
                                    return (
                                      floatValue >= 0 && floatValue < 99999999
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {/*													<TextField
															id={"total_s_iva_price."+idx}
															name={"total_s_iva_price."+idx}
															placeholder="Ingrese el valor total"
	//														value={(val.materials_s_iva_price !== undefined && val.materials_s_iva_price !== undefined) ? parseFloat(val.materials_s_iva_price) + parseFloat(val.workforce_s_iva_price) : 0}
															value={val.total_s_iva_price}
															onChange={this.handleChange}
															required
															margin="normal"
															className="m-0 p-0"
															InputLabelProps={{
																shrink: true
															}}
															inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
														/>
													*/}
                                <NumberFormat
                                  id={"total_s_iva_price." + idx}
                                  name={"total_s_iva_price." + idx}
                                  placeholder="Ingrese el valor total"
                                  disabled={
                                    val.workforce_s_iva_price > 0 ||
                                    val.materials_s_iva_price > 0
                                      ? true
                                      : false
                                  }
                                  value={val.total_s_iva_price}
                                  onChange={this.handleChange}
                                  className="m-0 p-0"
                                  InputProps={{
                                    style: {
                                      minWidth: 100,
                                      fontSize: "0.75rem"
                                    }
                                  }}
                                  decimalSeparator="."
                                  prefix={"$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  customInput={TextField}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  isAllowed={values => {
                                    let { floatValue } = values;
                                    floatValue =
                                      floatValue !== undefined ? floatValue : 0;
                                    return (
                                      floatValue >= 0 && floatValue < 99999999
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <Checkbox
                                  id={"bonificado." + idx}
                                  name={"bonificado." + idx}
                                  color="primary"
                                  checked={val.bonificado === true || +val.total_discount === +val.total_s_iva_price}
                                  onChange={this.handleChange}
                                  size="small"
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <IconButton size="small">
                                  <AddIcon
                                    onClick={e => {
                                      this.handleNewTask(e);
                                    }}
                                  />
                                </IconButton>
                                <IconButton size="small">
                                  <RemoveIcon
                                    onClick={e => {
                                      this.handleRemoveTask(e, idx);
                                    }}
                                  />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      })}
                      <TableRow>
                        <TableCell className={classes.tableCell} colSpan={3}>
                          Descuentos
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          <NumberFormat
                            id={"workforce_discount"}
                            name={"workforce_discount"}
                            placeholder="Ingrese el descuento de mano de obra"
                            value={this.state.workforce_discount}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 100, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"%"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99;
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          <NumberFormat
                            id={"materials_discount"}
                            name={"materials_discount"}
                            placeholder="Ingrese el descuento de materiales"
                            value={this.state.materials_discount}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 100, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"%"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99;
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          <NumberFormat
                            id={"total_discount"}
                            name={"total_discount"}
                            placeholder="Ingrese el descuento total"
                            value={this.state.total_discount}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 100, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"%"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99;
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tableCell}
                          colSpan={3}
                          style={{ fontSize: "0.75rem" }}
                        >
                          Subtotales
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          ${subtotals.price.workforce}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          ${subtotals.price.materials}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.75rem" }}
                        >
                          ${subtotals.price.total}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          &nbsp;
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <div className="ml-4">
                  <MediaComponent
                    media={this.state.media}
                    onChange={this.handleUpload}
                    disabled={this.state.disabled}
                  />
                </div>
                {this.state.action !== "view" ? (
                  <div className="row mt-2 ml-4">
                    <Button
                      className="mt-3"
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ fontSize: "0.75rem" }}
                      onClick={this.handleAddPresupuesto}
                    >
                      Guardar
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="row mt-2 ml-4">
                  <ValetBudgetComponent
                    work_order={this.props.work_order}
                    budget_id={this.state.id}
                    show_detail={true}
                  />
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </Dialog>
        <CompareBudgets
          open={this.state.openCompare}
          onClose={this.handleCloseCompare}
          budgets={this.state.budgets}
        />
        <Typography variant="caption">
          <Table
            size="small"
            aria-label="a dense table"
            style={{ width: "auto", minWidth: "650px", marginTop: "8px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Proveedor
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Estado
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Versión
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Mano de obra S/IVA
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Repuestos S/IVA
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Total S/IVA
                </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ fontWeight: "550" }}
              >
                Dif. %
              </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  &nbsp;
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.budgets.map((val, idx) => {
                var options = [
                  { name: "Verificar" },
                  { name: "Exportar detallado" },
                  { name: "Exportar cerrado" },
                  { name: "Editar" },
                  { name: "Ver" }
                ];
                if (val.budget_state_id === 2) {
                  options = [
                    { name: "Editar" },
                    { name: "Exportar detallado" },
                    { name: "Exportar cerrado" },
                    { name: "Ver" }
                  ];
                  if (this.state.budget_component === "ValetBudget") {
                    options = [
                      { name: "Editar" },
                      { name: "Exportar detallado" },
                      { name: "Exportar cerrado" },
                      { name: "Ver" }
                    ];
                  }
                }
                if (val.budget_state_id === 1) {
                  options = [{ name: "Editar" }];
                }
                if (val.budget_state_id === 4) {
                  options = [{ name: "Ver" }];
                }

                if (!this.props.can_cancel) {
                  options = [{ name: "Ver" }];
                }
                if (this.props.work_order.state === "cerrada") {
                  options = [
                    { name: "Exportar detallado" },
                    { name: "Exportar cerrado" },
                    { name: "Ver" }
                  ];
                }

                return (
                  <React.Fragment>
                    <TableRow key={idx}>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {/* <Checkbox
								            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
								            checkedIcon={<CheckBoxIcon fontSize="small" />}
								            name="checkedI"
								          />
								      		*/}
                        <a
                          href={"/provider/" + val.provider.id + "/0"}
                          target="_blank"
                        >
                          {val.provider.business_name}
                        </a>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Typography variant="caption">
                          {val.due_date_days < 3 ? (
                            <i class="text-danger font-weight-bold material-icons">
                              warning
                            </i>
                          ) : (
                            ""
                          )}
                          {val.state}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Typography variant="caption">{val.version}</Typography>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Typography variant="caption">
                          ${val.total_workforce ? val.total_workforce : 0}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Typography variant="caption">
                          ${val.total_materials ? val.total_materials : 0}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Typography variant="caption">
                          {this.state.budget_component !== "ValetBudget" ? (
                            <span>${val.total_budget}</span>
                          ) : (
                            <span>${val.total_s_iva_price}</span>
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {(() => {
                          const total = this.state.budget_component !== "ValetBudget" ? parseMoney(val.total_budget || 0) : parseMoney(val.total_s_iva_price || 0);
                          const base = approvedTotal;
                          const pct = base > 0 ? (((+total - base) / base) * 100) : 0;
                          const pctFixed = Number(pct.toFixed(1));
                          const color = pctFixed === 0 ? undefined : (pctFixed > 0 ? "#d32f2f" : "#2e7d32");
                          const sign = pctFixed > 0 ? "+" : "";
                          return (
                            <Chip
                              size="small"
                              label={`${sign}${pctFixed}%`}
                              style={{ fontSize: "0.7rem", height: 20, color: color }}
                            />
                          );
                        })()}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <MenuActions
                          id={idx}
                          options={options}
                          handleAction={this.handleMenuAction}
                        />
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </Typography>
        <Col>
          <Button
            disabled={this.props.work_order.state === "cerrada" ? true : false}
            className="mt-3"
            variant="contained"
            color="primary"
            size="small"
            style={{ fontSize: "0.75rem" }}
            onClick={this.handleNewPresupuesto}
          >
            Agregar presupuesto
          </Button>
          <Button
            className="mt-3 ml-2"
            variant="outlined"
            color="primary"
            size="small"
            style={{ fontSize: "0.75rem" }}
            onClick={this.handleOpenCompare}
          >
            Comparar
          </Button>
        </Col>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Budget);
